export const DEFAULT_SUB_VERTICAL = 'homes';

export function withSubVertical(params: URLSearchParams, subVertical: string): URLSearchParams {
    const next = new URLSearchParams(params);
    next.set('subVertical', subVertical);
    return next;
}
